import { Trans } from '@lingui/macro';
import { Dialog } from '@economic/taco';
import pensopayLogo from '../assets/pensopay-logo.png';

const DialogFooter = () => {
    return (
        <Dialog.Footer className="flex justify-between bg-grey-100 -mb-6 -mx-6 p-6">
            <div className="flex">
                <Trans>Payment Link offered in cooperation with</Trans>{' '}
                <img style={{ height: '23px', width: 'auto' }} src={pensopayLogo} alt="pensopay-logo" />
            </div>
        </Dialog.Footer>
    );
};

export default DialogFooter;
